import TextArea from 'components/TextArea'
import { useField, useFormikContext } from 'formik'
import React from 'react'
import styled from 'styled-components'

type TextareaProps = {
  onChange?: Function
  label?: string
  className?: string
  placeholder?: string
  tooltip?: string
  required?: boolean
  maxLength?: any
  name: string
  disable?: boolean
  validate?: (value: any) => undefined
}

const Textarea = (props: TextareaProps) => {
  const {
    label,
    className,
    onChange,
    required,
    maxLength,
    placeholder,
    name,
    disable,
    ...rest
  } = props
  const [field, meta] = useField(name)
  const { setFieldValue, submitCount } = useFormikContext()
  const error = submitCount > 0 ? meta.error : undefined

  return (
    <div className={className}>
      <div className={error ? 'input-error red' : ''}>
        <label
          htmlFor={field.name}
          className={`
            input-label-style
            ${error ? 'red' : 'dim'}
            ${required ? 'input-required' : ''}
          `}
        >
          {label}
        </label>
        <TextArea
          value={field.value}
          maxLength={maxLength}
          placeholder={placeholder}
          disabled={disable}
          onChange={(event) => {
            setFieldValue(field.name, event.target.value)
            if (onChange) {
              onChange(event.target.value)
            }
          }}
          {...rest}
        />
      </div>
      {error && <span className="input-helper red">{error}</span>}
    </div>
  )
}

Textarea.displayName = 'TextArea'

export default styled(Textarea)`
  label {
    font-weight: bold;
  }

  .input-required {
    &:after {
      content: '*';
    }
  }

  textarea {
    width: 100%;
    padding: 8px 8px;
    display: inline-block;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid ${(props) => props.theme.colors.grayMedium};
    margin-top: 5px;
    outline: none;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;

    &:focus {
      box-shadow: none;
    }
    &:focus-within {
      border: 2px solid ${(props) => props.theme.clientColors.secondary};

      &:after {
        display: none;
      }
    }
  }
`
